import i18next from 'i18next';
import { ClinicInvoiceTerm } from 'infrastructure/enums';

export interface IClinicInvoiceTermItem {
  id: ClinicInvoiceTerm;
  name: string;
}

export const clinicInvoiceTermsDataSource = (): IClinicInvoiceTermItem[] => {
  return [
    {
      id: ClinicInvoiceTerm.NET_30,
      name: i18next.t('clinicInvoiceTerms.net30'),
    },
    {
      id: ClinicInvoiceTerm.NET_45,
      name: i18next.t('clinicInvoiceTerms.net45'),
    },
    {
      id: ClinicInvoiceTerm.NET_60,
      name: i18next.t('clinicInvoiceTerms.net60'),
    },
    {
      id: ClinicInvoiceTerm.NET_90,
      name: i18next.t('clinicInvoiceTerms.net90'),
    },
  ];
};
